var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import * as React from "react";
import { PhonesexNumbers } from "./PhonesexNumbers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/pro-solid-svg-icons/faPhoneAlt";
import styled from 'styled-components';
import { Price } from "./Price";
export var AdvertisementConfigurable = function (_a) {
  var banner = _a.banner;
  var color = banner.color,
    color2 = banner.color2,
    color3 = banner.color3,
    lightness = banner.lightness,
    category = banner.category;
  var ages = [12, 16];
  var agePicture = 12;
  if (ages.includes(age)) {
    agePicture = age;
  } else if (age === 18) {
    agePicture = 16;
  }
  var Card = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t\tbackground-size: contain;\n\t\tpadding-bottom: 13px;\n\t\tmargin-bottom: 6px;\n\t\tbackground-color: ", ";\n\t\tbackground-image: url(\"/img/telefonsex/", "/", ".avif\");\n\t\tbackground: url(/img/telefonsex/", "/", ".avif) bottom right no-repeat, -moz-radial-gradient(center,ellipse cover,", " 1%,", " 100%);\n\t\tbackground: url(/img/telefonsex/", "/", ".avif) bottom right no-repeat, -webkit-radial-gradient(center,ellipse cover,", " 1%,", " 100%);\n\t\tbackground: url(/img/telefonsex/", "/", ".avif) bottom right no-repeat, radial-gradient(ellipse at center,", " 1%,", " 100%);\n\t\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='", "',endColorstr='", "',GradientType=1)\n"], ["\n\t\tbackground-size: contain;\n\t\tpadding-bottom: 13px;\n\t\tmargin-bottom: 6px;\n\t\tbackground-color: ", ";\n\t\tbackground-image: url(\"/img/telefonsex/", "/", ".avif\");\n\t\tbackground: url(/img/telefonsex/", "/", ".avif) bottom right no-repeat, -moz-radial-gradient(center,ellipse cover,", " 1%,", " 100%);\n\t\tbackground: url(/img/telefonsex/", "/", ".avif) bottom right no-repeat, -webkit-radial-gradient(center,ellipse cover,", " 1%,", " 100%);\n\t\tbackground: url(/img/telefonsex/", "/", ".avif) bottom right no-repeat, radial-gradient(ellipse at center,", " 1%,", " 100%);\n\t\tfilter: progid:DXImageTransform.Microsoft.gradient(startColorstr='", "',endColorstr='", "',GradientType=1)\n"])), color, agePicture, category, agePicture, category, color, color2, agePicture, category, color, color2, agePicture, category, color, color2, color, color2);
  var Span = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tbackground: ", " !important;\n"], ["\n\tbackground: ", " !important;\n"])), color3);
  var Phone = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tbackground: ", " !important;\n"], ["\n\tbackground: ", " !important;\n"])), color3);
  var phoneNumber = PhonesexNumbers[category].number[ABTestOption] + " " + callData.webmasterDDI;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Card, {
    className: "configured-phonesex-card c-phonesex-banner ".concat(category, " ").concat(lightness, " a").concat(agePicture)
  }, /*#__PURE__*/React.createElement("h3", {
    className: "phonesex-card-teasertext c-phonesex-banner__teaser",
    dangerouslySetInnerHTML: {
      __html: PhonesexNumbers[category].advertisement
    }
  }), /*#__PURE__*/React.createElement(Span, null, "Ruf jetzt an:"), /*#__PURE__*/React.createElement(Phone, {
    className: "phone c-phonesex-banner__phone"
  }, /*#__PURE__*/React.createElement("a", {
    href: "tel:" + phoneNumber
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faPhoneAlt
  }), " ", phoneNumber, /*#__PURE__*/React.createElement("sup", null, "*")))), /*#__PURE__*/React.createElement(Price, null));
};
var templateObject_1, templateObject_2, templateObject_3;